/**
 * MarkersPanelWrapper Component
 * Floating panel wrapper for Markers & Regions
 */

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MarkersRegionsPanel } from '../../MarkersRegions';
import { toast } from 'sonner';

export const MarkersPanelWrapper = ({
  isOpen,
  markers,
  regions,
  addMarker,
  updateMarker,
  deleteMarker,
  addRegion,
  updateRegion,
  deleteRegion,
  setCurrentTime,
  audioContextRef,
  playbackStartTimeRef,
  currentTime,
  totalDuration,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 20 }}
          className="fixed right-4 top-20 w-[280px] z-40"
        >
          <MarkersRegionsPanel
            markers={markers}
            regions={regions}
            onAddMarker={(time, type) => {
              addMarker(time, type);
              toast.success('Marker added');
            }}
            onUpdateMarker={updateMarker}
            onDeleteMarker={(id) => {
              deleteMarker(id);
              toast.success('Marker deleted');
            }}
            onAddRegion={(start, end) => {
              addRegion(start, end);
              toast.success('Region added');
            }}
            onUpdateRegion={updateRegion}
            onDeleteRegion={(id) => {
              deleteRegion(id);
              toast.success('Region deleted');
            }}
            onJumpToTime={(time) => {
              setCurrentTime(time);
              if (audioContextRef?.current) {
                playbackStartTimeRef.current = audioContextRef.current.currentTime - time;
              }
            }}
            currentTime={currentTime}
            totalDuration={totalDuration}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MarkersPanelWrapper;
